import { BackgroundColor } from '@ampcore/ampcom-contracts'

import {
  CarouselBackgroundClasses,
  CarouselBackgroundColor
} from './CarouselColor.type'

const BACKGROUND_CLASS_MAP: Partial<
  Record<BackgroundColor, CarouselBackgroundClasses>
> = {
  [BackgroundColor.WHITE]: {
    bgClass: 'u-bgColorWhite',
    contrastClass: 'Content--brand'
  },
  [BackgroundColor.STONE]: {
    bgClass: 'u-bgColorStone',
    contrastClass: 'Content--brand'
  },
  [BackgroundColor.AMERIPRISE_BLUE]: {
    bgClass: 'u-bgColorBrand',
    contrastClass: 'Content--reversed'
  },
  [BackgroundColor.MIDNIGHT_BLUE]: {
    bgClass: 'u-bgColorMidnightBlue',
    contrastClass: 'Content--reversed'
  }
}

const DEFAULT_BACKGROUND_CLASSES: CarouselBackgroundClasses = {
  bgClass: 'u-bgColorWhite',
  contrastClass: 'Content--brand'
}

/** Unknown or unset values resolve to white/brand. */
export function resolveBackgroundClasses(
  backgroundColor?: CarouselBackgroundColor
): CarouselBackgroundClasses {
  if (!backgroundColor) {
    return DEFAULT_BACKGROUND_CLASSES
  }
  return BACKGROUND_CLASS_MAP[backgroundColor] ?? DEFAULT_BACKGROUND_CLASSES
}
